import { PageHeader } from '@fukuri-admins/ui/common';
import { getClientContractListLink } from '~/utils/getLinks';

type Props = {
  /**
   * パンくずに表示する利用企業名
   *
   * 「{clientName}の契約期間」形式で最後のパンくず要素に使用する
   */
  clientName: string;
};

/**
 * 企業契約期間 詳細ヘッダー Presentation コンポーネント
 *
 * breadcrumb: 企業契約期間 → {利用企業名}の契約期間（Figma: node-id 24490-60298）
 *
 * - PartnerAdmin は自パートナー前提のため、パートナー名のパンくずは不要（2 階層のみ）
 * - 編集・削除ボタンはここには置かない。編集導線は詳細 body の ViewHeader 側に配置する
 *   （internal 版 PartnerClientContractTermDetail と同じ配置。PEN-982）
 */
export const ClientContractTermDetailHeaderPresentation: React.FC<Props> = ({ clientName }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[
      { label: '企業契約期間', href: getClientContractListLink() },
      { label: `${clientName}の契約期間` },
    ]}
  />
);
